module.exports = __webpack_public_path__ + "img/video_error.cc1cb40b.svg";